import { sortArrayByObjectDateProp } from '../../../utils/helpers';
import { ORDERS } from '../../../utils/constants';

const sortChatHistory = (history) => {
  return sortArrayByObjectDateProp(history, 'createdAt', ORDERS.ASC);
};

export default sortChatHistory;
